<template>
    <rkm-layout-body title="Lista de fornecedor">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-fornecedor-create' })"
                color="primary"
                authorize="store-cadastro-fornecedor"
            >
                Cadastrar fornecedor
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/fornecedor/List'

export default {
    components: { List },
}
</script>